export default __webpack_public_path__ + "static/media/img-9.4710182c.jpg";